var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.994,
    height: 128.024,
    viewBox: "0 0 127.994 128.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-895.85 -423.125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(881.087 408.086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.887,192.28v54.446a9.77,9.77,0,0,1-9.613,9.572q-54.368.029-108.736,0a9.835,9.835,0,0,1-9.618-9.729V192.28c.411,0,.822.037,1.233.037h125.51C163.07,192.317,163.48,192.292,163.887,192.28ZM70.379,221.873H56.1c-3.152,0-5.343,2-5.4,4.842s2.207,4.977,5.4,4.981H84.653c3.14,0,5.368-2.014,5.409-4.846.041-2.9-2.207-4.986-5.409-4.994-4.755-.012-9.515,0-14.274,0Zm51.684,9.844c.867,0,1.739.029,2.606,0a4.932,4.932,0,0,0,0-9.827q-2.61-.074-5.216,0a4.932,4.932,0,0,0,0,9.827c.871.008,1.739-.021,2.61-.021Zm19.691,0c.871,0,1.739.029,2.606,0a4.932,4.932,0,0,0,0-9.827c-1.734-.049-3.477-.049-5.212,0a4.932,4.932,0,0,0,0,9.827c.867.008,1.739-.021,2.606-.021Z",
    transform: "translate(-21.157 -113.251)",
    fill: "#dfe9ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.64,66.153c.353-10.567,4.727-18.989,13.617-24.8,18.138-11.853,42.609-.386,45.236,21.13.148,1.233.214,2.466.321,3.67a30.6,30.6,0,0,1-4.336,15.339,33.922,33.922,0,0,1-8.664,9.239c-.312.164-.637.312-.941.493a29.452,29.452,0,0,1-21.808,3.822,34.836,34.836,0,0,1-10.427-4.316c-1.134-.949-2.314-1.85-3.395-2.857A29.526,29.526,0,0,1,119.64,66.153Z",
    transform: "translate(-70.467 -21.55)",
    fill: "#e80d48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.373,168.32A34.88,34.88,0,0,0,93.8,172.636a29.452,29.452,0,0,0,21.808-3.822c.3-.181.629-.329.941-.493.769,0,1.533.041,2.3.041l45.088.037v9.77c-.411,0-.822.037-1.233.037H37.233c-.411,0-.822-.025-1.233-.037V168.4l13.8-.037Z",
    transform: "translate(-21.204 -99.139)",
    fill: "#4c5960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.344,133.1l-33.583.041-13.789.037c0-5.113-.045-10.226,0-15.339a9.9,9.9,0,0,1,9.392-9.3c8.335-.029,16.67,0,25.006,0a29.464,29.464,0,0,0,9.6,21.722C81.03,131.254,82.21,132.15,83.344,133.1Z",
    transform: "translate(-21.175 -63.923)",
    fill: "#dfe9ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.369,133.176l-45.088-.037c-.769,0-1.533-.029-2.3-.041a33.863,33.863,0,0,0,8.664-9.239,30.6,30.6,0,0,0,4.336-15.339h24.545a9.864,9.864,0,0,1,9.864,9.77C279.4,123.259,279.373,128.22,279.369,133.176Z",
    transform: "translate(-136.634 -63.917)",
    fill: "#dfe9ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.547,264.225h14.283c3.2,0,5.45,2.1,5.409,4.994-.041,2.832-2.269,4.842-5.409,4.846H77.268c-3.2,0-5.45-2.1-5.409-5s2.252-4.829,5.4-4.838Q84.4,264.217,91.547,264.225Z",
    transform: "translate(-42.324 -155.625)",
    fill: "#4c5960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.319,274.044c-.871,0-1.739.029-2.606,0a4.932,4.932,0,0,1,0-9.827q2.606-.074,5.216,0a4.932,4.932,0,0,1,0,9.827C237.058,274.073,236.187,274.044,235.319,274.044Z",
    transform: "translate(-134.413 -155.6)",
    fill: "#f04f43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.229,274.044c-.867,0-1.739.029-2.606,0a4.932,4.932,0,0,1,0-9.827c1.734-.049,3.477-.049,5.212,0a4.932,4.932,0,0,1,0,9.827C284.968,274.073,284.1,274.044,283.229,274.044Z",
    transform: "translate(-162.631 -155.6)",
    fill: "#f04f43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(944.97 438.465)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.539 5.539)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 19,
    y2: 19,
    transform: "translate(0.492 -0.003)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y2: 19,
    transform: "translate(0.492 -0.003)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment-failed.7f955a0a07663f6ff7699e178ba8ed25.svg";
export { ForwardRef as ReactComponent };